import React, { FC } from 'react';
import { Trans } from 'react-i18next';
import styled from 'styled-components';
import {
  Container,
  InfoColumn,
  InfoLabel,
  InfoRow,
  Subtitle,
} from 'src/front/components/FormStyles';
import { PaymentPlanSimCalculationResult } from './PaymentPlanSimulation';

const VerticalInfoColumn = styled(InfoColumn)`
  display: flex;
  width: 25%;
  flex-direction: column;

  margin: 10px 0;

  & > div {
    margin-bottom: 5px;
  }
`;

const VerticalColumn = styled.div`
  display: flex;
  width: 45%;
  flex-direction: column;

  margin: 10px 0;
`;

const InfoProperty = styled(InfoLabel)`
  width: 100%;
  font-weight: bold;
`;

interface Props {
  result?: PaymentPlanSimCalculationResult;
  carLoan?: boolean;
}

const CalculationDetails: FC<Props> = ({ result, carLoan }) => {
  return (
    <Container>
      <InfoRow>
        <Subtitle>
          <Trans i18nKey="PPSimulation_calculation_result_subtitle" />
        </Subtitle>
      </InfoRow>
      <InfoRow>
        <VerticalInfoColumn>
          <InfoProperty>
            <Trans i18nKey="loanApp_productDetail_loanAmount_label" />
          </InfoProperty>
          <InfoLabel>{result?.loanAmount || ''}</InfoLabel>
        </VerticalInfoColumn>
        <VerticalInfoColumn>
          <InfoProperty>
            <Trans
              i18nKey={`${
                carLoan
                  ? 'PPSimulation_calculation_annualInterest_text'
                  : 'PPSimulation_calculation_loanInterestRate_label'
              }`}
            />
          </InfoProperty>
          <InfoLabel>{result?.loanInterestRate || ''}</InfoLabel>
        </VerticalInfoColumn>
      </InfoRow>
      <InfoRow>
        <VerticalInfoColumn>
          <InfoProperty>
            <Trans i18nKey="loanApp_productDetail_initialPaymentPercentage_label" />
          </InfoProperty>
          <InfoLabel>{result?.initialPaymentRate || ''}</InfoLabel>
        </VerticalInfoColumn>
        <VerticalInfoColumn>
          <InfoProperty>
            <Trans i18nKey="loanApp_productDetail_initialPayAmount_label" />
          </InfoProperty>
          <InfoLabel>{result?.initialPaymentAmount || ''}</InfoLabel>
        </VerticalInfoColumn>
      </InfoRow>
      {!carLoan ? (
        <InfoRow>
          <VerticalColumn>
            <InfoProperty>
              <Trans i18nKey="PPSimulation_calculation_insurance_label" />
            </InfoProperty>
            <InfoLabel>{result?.lifeComm || ''}</InfoLabel>
          </VerticalColumn>
        </InfoRow>
      ) : null}
      <InfoRow>
        <VerticalInfoColumn>
          <InfoProperty>
            <Trans i18nKey="PPSimulation_calculation_loanPayment_label" />
          </InfoProperty>
          <InfoLabel>{result?.loanPaymentMonthly || ''}</InfoLabel>
        </VerticalInfoColumn>
        <VerticalInfoColumn>
          <InfoProperty>
            <Trans i18nKey="PPSimulation_calculation_fullCost_label" />
          </InfoProperty>
          <InfoLabel>{result?.fullLoanCost || ''}</InfoLabel>
        </VerticalInfoColumn>
      </InfoRow>
    </Container>
  );
};

export default CalculationDetails;
